import React from 'react';

import {SkeletonTypes, SkeletonItem as UIKITSkeletonItem} from '@pb/kit-component-skeleton';

import {skeletonItem} from './skeleton-item.module.styl';

type Props = {
    width: number | string,
    height: number,
    circle?: boolean,
};

export const SkeletonItem: React.FC<Props> = ({width, height, circle}) => (
    <UIKITSkeletonItem
        variant={circle ? SkeletonTypes.CIRCLE : SkeletonTypes.RECTANGLE}
        width={width}
        height={height}
        className={skeletonItem}
    />
);
